import { DotLottie } from '@lottiefiles/dotlottie-web';
import { inflate } from 'pako';
import { sleep } from '~/lib/sleep';

export async function loadTgsCanvas(options: {
  uint8Array: Uint8Array;
  autoplay: boolean;
  canvasRef: { current: HTMLCanvasElement | null };
  loop: boolean;
  hasUnmounted: () => boolean;
  onComplete: () => void;
  onLoaded: () => void;
}) {
  // TGS file - decompress
  const data = inflate(options.uint8Array, { to: 'string' });

  async function waitForCanvasElement() {
    const canvas = options.canvasRef.current;

    if (options.hasUnmounted()) {
      return null;
    }

    if (!canvas) {
      // try again later
      const SLEEP_MS = 500;
      await sleep(SLEEP_MS);
      return await waitForCanvasElement();
    } else {
      return canvas;
    }
  }

  const canvas = await waitForCanvasElement();

  if (!canvas) {
    return;
  }

  const dotLottie = new DotLottie({
    autoplay: false,
    loop: options.loop,
    canvas,
    data,
  });

  dotLottie.addEventListener('load', () => {
    const isStatic = dotLottie.totalFrames <= 1;

    if (!isStatic && options.autoplay) {
      dotLottie.play();
    }

    options.onLoaded();
  });

  dotLottie.addEventListener('complete', () => {
    options.onComplete();
  });

  return {
    subscription: {
      unsubscribe: () => {
        dotLottie.destroy();
      },
    },
  };
}
